import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { ButtonModule } from 'primeng/button';
import { CardModule } from 'primeng/card';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { DropdownModule } from 'primeng/dropdown';
import { CommonModule } from '@angular/common';
import { FormBuilder, FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { CalendarModule } from 'primeng/calendar';
import { InputTextModule } from 'primeng/inputtext';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { TagModule } from 'primeng/tag';
import { SelectButtonModule } from 'primeng/selectbutton';
import { TableModule } from 'primeng/table';
import { FileUploadModule } from 'primeng/fileupload';
import { GenericButtonComponent } from "../../../../global/component/generic/generic-button/generic-button.component";
import { ConfirmationService, MessageService } from 'primeng/api';
import { AddExpenseService } from '../../../services/add-expense.service';
import { AutocompleteService } from '../../../services/autocomplete.service';
import { DialogModule } from 'primeng/dialog';
import { EntityType } from '../../../models/ConstantsAndEnums';
import { catchError, debounceTime, distinctUntilChanged } from 'rxjs';
import { ExpenseLineItemModel } from '../../../models/ExpenseLineItemModel';
import { ExpenseAttachmentModel } from '../../../models/ExpenseAttachmentModel';
import { restrictToTwoDecimals } from '../../../../global/util/util';

@Component({
  selector: 'expense-add-lineitems',
  templateUrl: './expense-add-lineitems.component.html',
  styleUrls: ['./expense-add-lineitems.component.scss'],
  imports: [ButtonModule, CardModule, AutoCompleteModule, DropdownModule, CommonModule, CalendarModule, InputTextModule, InputTextareaModule, TagModule,
    SelectButtonModule, TableModule, FileUploadModule, GenericButtonComponent, ReactiveFormsModule, DialogModule, ReactiveFormsModule],
  standalone: true,
  providers: [
    ConfirmationService,
    MessageService,
    AddExpenseService,
    AutocompleteService
  ],
})
export class ExpenseAddLineItemsComponent implements OnInit {
  expenselineitemForm!: FormGroup;
  expenseitemForm!: FormGroup;
  @Input() campaignId!: number;
  @Input() expenseId!: number;
  @Input() expenseDetails: any;
  @Input() confirmAction!: (
    message: string,
    acceptCallback: () => void,
    rejectCallback?: () => void
  ) => void;
  @Output() prevCallback = new EventEmitter<void>();
  @Output() nextCallback = new EventEmitter<void>();
  @Output() errorEvent = new EventEmitter<string>();
  isEdit = false;
  lineItemDialog = false;
  lineAttachmentDialog = false;
  lineItems: ExpenseLineItemModel[] = [];
  attachments: ExpenseAttachmentModel[] = []
  eventSuggestions: any = [];
  accountSuggestions: any = [];


  constructor(private fb: FormBuilder, private addExpenseService: AddExpenseService, private autoCompleteService: AutocompleteService, private confirmationService: ConfirmationService) { }

  ngOnInit(): void {
    this.initForm();
    this.addExpenseService.getExpenselineitems(this.expenseId, false).subscribe({
      next: (data) => {
        this.lineItems = data;
        this.lineItemDialog = false;
      },
      error: () => {
        this.errorEvent.emit('Failed to get new LineItem Details');
      }
    });
    this.addExpenseService.getExpenselineattachments(this.expenseId).subscribe({
      next: (data) => {
        this.attachments = data;
      },
      error: () => {
        this.errorEvent.emit('Failed to get new LineItem Details');
      }
    });
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['expenseDetails']?.currentValue) {
    }
  }

  initForm() {
    this.expenselineitemForm = this.fb.group({
      requestId: [''],
      lineItemId: [''],
      lineNumber: [''],
      lineItem_CampaignId: [''],
      lineItem_RequestedAmount: ['', Validators.required],
      event: [''],
      eventId: [''],
      account: ['', Validators.required],
      glAccountId: ['', Validators.required],
    });

    this.expenseitemForm = this.fb.group({
    });
  }
  onSubmit() {
    if (this.lineItems.length > 0) {
      this.nextCallback.emit();
    }
    else {
      this.errorEvent.emit('Atleast one line item is required!');
    }
  }

  saveLineItem(isEdit: boolean) {
    if (isEdit) {
      if (this.expenselineitemForm.valid) {
        this.addExpenseService.updateExpenselineitem(this.expenselineitemForm.value).subscribe({
          next: () => {
            this.addExpenseService.getExpenselineitems(this.expenseId, false).subscribe({
              next: (data) => {
                this.lineItems = data;
                this.lineItemDialog = false;
              },
              error: () => {
                this.errorEvent.emit('Failed to get new LineItem Details');
              }
            });
          },
          error: () => {
            this.errorEvent.emit('Failed to save LineItem Details');
          }
        });
      } else {
        this.markAllAsTouched(this.expenselineitemForm);
      }
    }
    else {
      if (this.expenselineitemForm.valid) {
        this.addExpenseService.saveExpenselineitem(this.expenselineitemForm.value).subscribe({
          next: () => {
            this.addExpenseService.getExpenselineitems(this.expenseId, false).subscribe({
              next: (data) => {
                this.lineItems = data;
                this.lineItemDialog = false;
              },
              error: () => {
                this.errorEvent.emit('Failed to get new LineItem Details');
              }
            });
          },
          error: () => {
            this.errorEvent.emit('Failed to save LineItem Details');
          }
        });
      } else {
        this.markAllAsTouched(this.expenselineitemForm);
      }
    }
  }

  markAllAsTouched(formGroup: FormGroup) {
    Object.keys(formGroup.controls).forEach((field) => {
      formGroup.get(field)?.markAsTouched();
    });
  }

  openLineItemDialog() {
    this.isEdit = false;
    this.expenselineitemForm.reset();
    this.expenselineitemForm.get('requestId')?.setValue(this.expenseId);
    this.expenselineitemForm.get('lineItem_CampaignId')?.setValue(this.campaignId);
    this.expenselineitemForm.get('lineItemId')?.setValue('0');
    this.expenselineitemForm.get('lineNumber')?.setValue(this.lineItems!== null ? this.lineItems.length + 1 :'1');
    this.lineItemDialog = true;
  }

  openLineItemAttachmentDialog() {
    this.lineAttachmentDialog = true;
  }

  editLineItemDialog(item: ExpenseLineItemModel) {
    this.isEdit = true;
    console.debug(item);
    this.expenselineitemForm.get('requestId')?.setValue(this.expenseId);
    this.expenselineitemForm.get('lineItem_CampaignId')?.setValue(this.campaignId);
    this.expenselineitemForm.get('lineItemId')?.setValue(item.lineItemID);
    this.expenselineitemForm.get('lineNumber')?.setValue(item.lineNumber);
    this.expenselineitemForm.get('lineItem_RequestedAmount')?.setValue(item.lineItem_RequestedAmount);
    this.expenselineitemForm.get('event')?.setValue(item.eventDescription);
    this.expenselineitemForm.get('account')?.setValue(item.glAccountDisplayText);
    this.expenselineitemForm.get('glAccountId')?.setValue(item.glAccountId),
    this.lineItemDialog = true;
  }

  deleteLineItem(item: ExpenseLineItemModel) {
    this.confirmAction?.('Are you sure you want to delete this line item?',
      () => {
        this.addExpenseService.deleteExpenselineitem(item.lineItemID).subscribe({
          next: () => {
            this.addExpenseService.getExpenselineitems(this.expenseId, false).subscribe({
              next: (data) => {
                this.lineItems = data;
              },
              error: () => {
                this.errorEvent.emit('Failed to get new LineItem Details');
              }
            });
          },
          error: () => {
            this.errorEvent.emit('Failed to delete line item');
          }
        })
      },
      () => {  //Reject Functionality
      }
    );
  }

  deleteLineAttachmentItem(item: ExpenseAttachmentModel) {
    this.confirmAction?.(`Are you sure you want to delete this line attachment item? ${item.fileName}`,
      () => {
        this.addExpenseService.deleteExpenselineattachment(item.attachmentId).subscribe({
          next: () => {
            this.addExpenseService.getExpenselineattachments(this.expenseId).subscribe({
              next: (data) => {
                this.attachments = data;
              },
              error: () => {
                this.errorEvent.emit('Failed to get new LineItem Details');
              }
            });
          },
          error: () => {
            this.errorEvent.emit('Failed to delete line attachment item');
          }
        })
      },
      () => {  //Reject Functionality
      }
    );
  }

  onCancel() {
    this.lineItemDialog = false;
  }

  searchEvent(query: string): void {
    if (!query) {
      this.eventSuggestions = [];
      return;
    }
    this.autoCompleteService.getAutoCompleteResults(query, EntityType.Events, this.campaignId).pipe(
      debounceTime(300),
      distinctUntilChanged(),
      catchError(() => [])
    ).subscribe((results) => {
      this.eventSuggestions = this.mapToLabelValue(results);
      this.expenselineitemForm.get('eventId')?.updateValueAndValidity();
    });
  }

  onFileUpload(event: any) {
    const files: File[] = event.files;
    if (!files || files.length === 0) {
      this.errorEvent.emit('Please select files to upload.');
      return;
    }
    const formData = new FormData();
    files.forEach(file => {
      formData.append('files', file, file.name);
      formData.append('ExpenseRequestId', this.expenseId.toString());
      formData.append('VendorId', this.expenseDetails.vendorId.toString());
      formData.append('InvoiceNumber', this.expenseDetails.invoicenumber.toString());
    });
    this.addExpenseService.saveExpenselineattachment(formData).subscribe({
      next: () => {
        this.addExpenseService.getExpenselineattachments(this.expenseId).subscribe({
          next: (data) => {
            this.attachments = data;
            this.lineAttachmentDialog = false;
          },
          error: () => {
            this.errorEvent.emit('Failed to get new LineAttachmentItem Details');
          }
        });
      },
      error: () => {
        this.errorEvent.emit('Failed to save LineAttachmentItems');
      }
    });
  }

  onEventSelect(event: any) {
    const eventId = event.value.value;
    this.expenselineitemForm.get('eventId')?.setValue(eventId);
  }

  searchAccount(query: string): void {
    if (!query) {
      this.accountSuggestions = [];
      return;
    }
    this.autoCompleteService.getAutoCompleteResults(query, EntityType.GLAccounts, this.campaignId).pipe(
      debounceTime(300),
      distinctUntilChanged(),
      catchError(() => [])
    ).subscribe((results) => {
      this.accountSuggestions = this.mapToLabelValue(results);
      this.expenselineitemForm.get('glAccountId')?.updateValueAndValidity();
    });
  }

  onAccountSelect(account: any) {
    const glAccountId = account.value.value;
    this.expenselineitemForm.get('glAccountId')?.setValue(glAccountId);
  }
  private mapToLabelValue(items: any[]): { label: string, value: string }[] {
    return items?.map((item: any) => ({ label: item.text, value: item.value })) || [];
  }
  onSaveExpense(): Promise<boolean> {
    return new Promise((resolve, reject) => {
      if (this.lineItems.length > 0) {
        resolve(true);
      }
      else {
        resolve(false);
        this.errorEvent.emit('Atleast one line item is required!');
      }
    });
  }

  onAmountInput(event: Event): void {
    const input = event.target as HTMLInputElement;
    input.value = restrictToTwoDecimals(input.value);
    this.expenselineitemForm.get('lineItem_RequestedAmount')?.setValue(input.value, { emitEvent: false });
  }
}
